import gql from 'graphql-tag';
import { FileFragments } from '@getaccept/dsr-shared-new/src/api/files/graphql/file.fragments';

export class FileQueries {
  static load = gql`
    query ListDealroomFiles(
      $limit: Float
      $offset: Float
      $sortBy: FileSortBy
      $sortOrder: SortOrder
      $searchTerms: [String!]
      $participantIds: [String!]
      $statuses: [FileStatus!]
    ) {
      listDealroomFiles(
        limit: $limit
        offset: $offset
        sortBy: $sortBy
        sortOrder: $sortOrder
        searchTerms: $searchTerms
        participantIds: $participantIds
        statuses: $statuses
      ) {
        files {
          ...fileFragment
        }
        totalCount
      }
    }
    ${FileFragments.file}
  `;

  static getDownloadUrl = gql`
    query DealroomFileDownloadLink($fileId: String!) {
      dealroomFileDownloadLink(fileId: $fileId) {
        presignedLink
      }
    }
  `;
}
